export const NotificationsMessageTypes = {
  error: "ERROR",
  info: "INFO",
  success: "SUCCESS",
  cancel: "CANCEL",
};
